export default function CustomerNameFilter() {
  /**
   * Get the name to display for the given customer.
   *
   * @function
   *
   * @param  {Customer} customer
   *         The customer to get the name of
   *
   * @return {String} Either company name, name or a combination of both
   */
  return function (customer) {
    if (!customer) {
      return
    }
    const name = (customer.name && String(customer.name).trim()) || ''
    const company =
      (customer.company_name && String(customer.company_name).trim()) || ''

    if (name && company) {
      return `${company}, ${name}`
    }

    return company || name
  }
}
